module.exports = "<div class=\"form-bubble mb-3\" [ngStyle]=\"{'background-color': bgColor}\">\n    <ng-content select=\"content\"></ng-content>\n</div>\n        "


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/field-ctn/field-ctn.component.html
// module id = ../../../../../src/app/brds/widgets/field-ctn/field-ctn.component.html
// module chunks = 10